import React, { FC } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { TColumnHeadingElement } from '../../types/index.types';

const ColumnHeadingElement: FC<TColumnHeadingElement> = (props) => {
  if (!props.colHeadings?.length) return null;
  return (
    <>
      {props.colHeadings
        ?.filter((_, columnIndex) => {
          if (!props.showHiddenRightCells) return columnIndex <= 5;
          return true;
        })
        .map((val) => {
          const text = val?.text;
          return (
            <th key={text?.value}>
              <div className="model-detail-specification-table__col-heading-dropdown__wrapper">
                <div className="model-detail-specification-table__col-heading model-detail-specification-table__col-heading--editorial-table">
                  {!!text && <Text field={text} editable={true} />}
                </div>
              </div>
            </th>
          );
        })}
    </>
  );
};

export default ColumnHeadingElement;
